// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","631":"contact","824":"portfolio"}[chunkId] + "." + {"443":"e944a846","631":"fbdb4914","824":"f55c1f64"}[chunkId] + ".css";
};